import { INavigationOptions } from '../types'

export const DEFAULT_NAVIGATION_OPTIONS: INavigationOptions = {
  enabled: false,
  next: { enabled: false, present: true, loading: false },
  prev: { enabled: false, present: false, loading: false }
}

export function setNavigationOptionsEnableNavigation(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    enabled: true
  }
}

export function setNavigationOptionsDisableNavigation(
  currentNavigationOptions: INavigationOptions
): INavigationOptions {
  return {
    ...currentNavigationOptions,
    enabled: false
  }
}

export function setNavigationOptionsEnableNext(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    next: {
      ...currentNavigationOptions.next,
      enabled: true
    }
  }
}

export function setNavigationOptionsDisableNext(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    next: {
      ...currentNavigationOptions.next,
      enabled: false
    }
  }
}

export function setNavigationOptionsEnablePrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: true
    }
  }
}

export function setNavigationOptionsDisablePrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: false
    }
  }
}

export function setNavigationOptionsShowPrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      present: true
    }
  }
}

export function setNavigationOptionsHidePrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      present: false
    }
  }
}

export function setNavigationOptionsPreNext(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: false
    },
    next: {
      ...currentNavigationOptions.next,
      enabled: false,
      loading: true
    }
  }
}

export function setNavigationOptionsPostNext(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: true
    },
    next: {
      ...currentNavigationOptions.next,
      enabled: false,
      loading: false
    }
  }
}

export function setNavigationOptionsPrePrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: false,
      loading: true
    },
    next: {
      ...currentNavigationOptions.next,
      enabled: false
    }
  }
}

export function setNavigationOptionsPostPrev(currentNavigationOptions: INavigationOptions): INavigationOptions {
  return {
    ...currentNavigationOptions,
    prev: {
      ...currentNavigationOptions.prev,
      enabled: false,
      loading: false
    },
    next: {
      ...currentNavigationOptions.next,
      enabled: false
    }
  }
}
